import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login';
import DocList from '@/views/update/UpdateList';
import Document from '@/views/update/Update';
import store from "@/store";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base:  window.__POWERED_BY_QIANKUN__ ? '/service/updates/' : '/',
    routes: [
        {path: '/login', component: Login, meta: {title: 'Вход'}},
        {path: '/', component: DocList, meta: {title: 'Список обновлений'}},
        {path: '/create', component: Document, meta: {title: 'Создание обновления'}, props: {creating: true}},
        {path: '/:platform/:major.:minor.:patch', component: Document, meta: {title: 'Просмотр обновления'}}
    ]
});

router.beforeEach(async (to, from, next) => {
    if (store.getters.isAuthorized == null) {
        await store.dispatch("refreshToken")
            .catch(error => {
                if (error.response?.status !== 401) {
                    console.error("Ошибка обновления токена", error);
                }
            });
    }

    if (!store.getters.isAuthorized && '/login' !== to.path) {
        return next('/login');
    }
    if (store.getters.isAuthorized && '/login' === to.path) {
        return next('/');
    }
    if (store.getters.isAuthorized && store.getters.isRolesEmpty && '/' !== to.path) {
        return next('/');
    }
    if (!store.getters.isAdmin && '/create' === to.path) {
        return next('/');
    }
    return next();
});

export default router;
